import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$da72 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as ipxRuntime$2d65 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "magento.extracts.pro"
  ],
  "alias": {
    "/img": "https://magento.extracts.pro"
  }
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$da72, defaults: {} },
  ['ipx']: { provider: ipxRuntime$2d65, defaults: {"baseURL":"https://images.cdn.extracts.pro/_ipx"} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
